import React from 'react'
import LoggedInCartOrderObserver, {
  LoggedInCartConsumer,
  LoggedInCartContext
} from './LoggedInCartObserver'
import GuestCartObserver, { GuestCartConsumer, GuestCartContext } from './GuestCartObserver'

// Grouped Provider
const CartProvider: React.FC<{}> = ({ children }) => {
  return (
    <GuestCartObserver>
      <LoggedInCartOrderObserver>{children}</LoggedInCartOrderObserver>
    </GuestCartObserver>
  )
}

export {
  CartProvider,
  LoggedInCartConsumer,
  LoggedInCartContext,
  GuestCartConsumer,
  GuestCartContext
}
